import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import router from './routes'
import 'font-awesome/css/font-awesome.min.css'
import api from './fetch/api'
import util from './scripts/common/util'

import tooltipHint from './components/TooltipHint.vue';

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

Vue.component("tooltip-hint",tooltipHint)


/**
 * 驼峰转 - 分割
 * eg: cameCase('TransferDom') => 'transfer-dom'
 * @param key
 * @returns {string}
 */
/*const cameCase = (key) => {
    return key.replace(/([A-Z])/g, (a, b) => '-' + b.toLowerCase()).replace(/^-/, '')
}

// 注册全局指令
Object.keys(directives).map(key => {
    // 这里的Key是TransferDom，转换后为transfer-dom
    // 注册指令时为transfer-dom，使用时要加前缀v。eg： v-transfer-dom 不是会自动转分割吗？
    Vue.directive(cameCase(key), directives[key])
})*/

Vue.prototype.$api = api
Vue.prototype.$util = util
//时间 8个时区问题
// import moment from 'moment';
// Vue.prototype.$moment = moment;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js